import {
  Entity,
  Fund,
  FundUnpublished,
  Investment,
  InvestmentRefEnum,
  LayoutData,
  LayoutEnum,
  Operator,
  Project,
  ProjectCategoryEnum,
  ProjectUnpublished,
  UpdatesColumn,
} from 'src/types.d';
import { v4 as uuidv4 } from 'uuid';
import { defaultCategories } from '../variables';
import { getIdAndUpdatedAtFromObject } from './getIdAndUpdatedAtFromObject';

export function getEntityStatus(
  // entity: Fund | Project | ProjectUnpublished | FundUnpublished,
  entity: Entity,
): string {
  return entity?.status;
}

export function isEntityStatusCompleted(
  entity: Fund | Project | ProjectUnpublished | FundUnpublished,
): boolean {
  const status = getEntityStatus(entity);
  return status && status.toLowerCase() === 'completed';
}
export function isEntityStatusCancelled(
  entity: Fund | Project | ProjectUnpublished | FundUnpublished,
): boolean {
  const status = getEntityStatus(entity);
  return status && status.toLowerCase() === 'cancelled';
}

export function getCurrency(entity: Fund | Project | ProjectUnpublished | FundUnpublished): string {
  return entity?.currency || 'USD';
}

export function getEntityName(
  entity: Fund | Project | ProjectUnpublished | FundUnpublished,
): string {
  return entity?.name || '';
}

export const getLegalEntityName = (entity: { name: string; uniqueId: string }) => {
  let name = entity.name;
  if (entity.uniqueId !== name) {
    name += ` (${entity.uniqueId})`;
  }
  return name;
};

export function getEntityCategory(entity): string {
  return entity?.entityType === 'Fund'
    ? 'fund'
    : entity?.customCategory?.toLowerCase() ||
        (entity?.category === 'custom' ? 'other' : entity?.category?.toLowerCase()) ||
        '';
}

// Goes over all operator's entities names, returns the max value+1 for new entity name
export function getNewProjectsCount(entities: Entity[], type: string) {
  return (
    entities.reduce((acc, entity) => {
      const tempProj = entity.name.toLowerCase().includes(`new ${type}`) ? entity.name : '';
      if (!tempProj) {
        return acc;
      } else {
        //extract the number from the name
        const matches = tempProj.match(/\d+/);
        const newProjCounter = matches ? parseInt(matches[0]) : 0;
        return newProjCounter > acc ? newProjCounter : acc;
      }
    }, 0) + 1
  );
}

export function isProjectInvestment(investment: Investment): boolean {
  return investment?.ref[0].key === InvestmentRefEnum.projectId;
}

export function isFundInvestment(investment: Investment): boolean {
  return investment?.ref[0].key === InvestmentRefEnum.fundId;
}

export function getClientId(obj: any) {
  return obj?.id ? obj.id : uuidv4();
}

export function setLayoutAfterUpdateColChange(
  object: Entity | Operator,
  columns: UpdatesColumn[],
): LayoutData[] {
  const layoutData: LayoutData = {
    key: LayoutEnum.updatesDetails,
    value: columns,
  };

  return object?.layout
    ? object?.layout.map(x => (x?.key === LayoutEnum.updatesDetails ? layoutData : x))
    : [layoutData];
}

export function getObjectWithUpdatedCategory(obj, newCategory: string) {
  const updatedObj = {
    ...getIdAndUpdatedAtFromObject(obj),
  };

  if (defaultCategories.find(category => category.toLowerCase() === newCategory?.toLowerCase())) {
    updatedObj['category'] = newCategory?.toLowerCase();
    updatedObj['customCategory'] = null;
  } else {
    updatedObj['category'] = ProjectCategoryEnum.custom;
    updatedObj['customCategory'] = newCategory?.toLowerCase();
  }

  return updatedObj;
}
